var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"mr-2",attrs:{"icon":"","outlined":_vm.outlined,"text-color":_vm.textColor,"color":_vm.color,"x-small":""}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }